class LazyImg {
    constructor(images, options = {}){
        this.options = Object.assign(
            {},
            {    
                targetPos: "",
                addpixel: 200
            }, 
            options
        ); 
        this.images = images;   
        if(typeof IntersectionObserver != "undefined"){
            this.config = {  
                threshold: 0
            }
            this.observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => { 
                    if (entry.isIntersecting) { 
                        const image = entry.target;
                        let containerWidth = image.closest("div").offsetWidth; 
                        let containerHeight = image.closest("div").offsetHeight; 
                        let lcpMob = false; 
                        if(window.innerWidth < 992 && image.classList.contains("lcp")){
                            lcpMob = true;
                        }
                        if(!lcpMob){
                            let urls;
                            let closest;
                            if(image.classList.contains("ext")){
                                const url = image.getAttribute("data-src"); 
                                image.src = url;
                                image.classList.add("loaded");  
                            }else{ 
                                //let windowWidth = window.innerWidth; 
                                containerHeight += this.options.addpixel;
                                let sizes = [1400, 1200, 1000, 800, 600, 500, 400, 300, 200];
                                if(containerHeight > containerWidth){
                                    closest = sizes.reduce(function(prev, curr) {
                                        return (Math.abs(curr - containerHeight) < Math.abs(prev - containerHeight) ? curr : prev);
                                    }); 
                                    urls = {
                                        1400 : image.getAttribute("data-src-1400h"),
                                        1200 : image.getAttribute("data-src-1200h"),
                                        1000 : image.getAttribute("data-src-1000h"),
                                        800 : image.getAttribute("data-src-800h"),
                                        600 : image.getAttribute("data-src-600h"),
                                        500 : image.getAttribute("data-src-500h"),
                                        400 : image.getAttribute("data-src-400h"),
                                        300 : image.getAttribute("data-src-300h"),
                                        200 : image.getAttribute("data-src-200h")
                                    }; 
                                }else{
                                    containerWidth += this.options.addpixel;
                                    closest = sizes.reduce(function(prev, curr) {
                                        return (Math.abs(curr - containerWidth) < Math.abs(prev - containerWidth) ? curr : prev);
                                    }); 
                                    urls = {
                                        1400 : image.getAttribute("data-src-1400w"),
                                        1200 : image.getAttribute("data-src-1200w"),
                                        1000 : image.getAttribute("data-src-1000w"),
                                        800 : image.getAttribute("data-src-800w"),
                                        600 : image.getAttribute("data-src-600w"),
                                        500 : image.getAttribute("data-src-500w"),
                                        400 : image.getAttribute("data-src-400w"),
                                        300 : image.getAttribute("data-src-300w"),
                                        200 : image.getAttribute("data-src-200w")
                                    }; 
                                }   
                                image.src = urls[closest];
                                image.classList.add("loaded");    
                            } 
                        }
                    }
                });
            }, this.config);  
            this.images.forEach(image => {
                this.observer.observe(image);
            });
        }else{
            this.images.forEach(image => {
                let dHref = image.getAttribute("data-src");
                image.src = dHref; 
            });
        } 
    }    
}


var lazyImg = new LazyImg(document.querySelectorAll("img.lazy"));